module.exports = __webpack_public_path__ + "static/media/03.edfd59e5.jpg";